import { useSettingsAIAgentLocation } from 'app/components/settings-ai-agent-location/useSettingsAIAgentLocation'
import { SettingsAIAgentLocationComponent } from 'app/components/settings-ai-agent-location/SettingsAIAgentLocationComponent'

export default function LocationView() {
  const props = useSettingsAIAgentLocation()
  return <SettingsAIAgentLocationComponent {...props} />
}
